import { getStorebrandClient } from "Api/clients/storebrand";
import { HouseContentsStandard } from "./";

export async function getSuggestedHouseContentsInsuranceAmount({
  people,
  rooms,
  houseContentsStandard,
}: {
  people: number;
  rooms: number;
  houseContentsStandard: HouseContentsStandard;
}): Promise<number> {
  const client = await getStorebrandClient();
  const response = await client.post<number>(
    "/open/insurance/risk/price/housecontents/insuranceamount",
    {
      people,
      rooms,
      houseContentsStandard,
    },
  );
  return response.data;
}
